// @flow
import TextArea from './TextArea'
import { createFormGroupField } from '@src/components/ui/FormGroup'

export default createFormGroupField(TextArea)
